<template>
  <v-row align="center" justify="center">
    <v-col class="text-center pt-0 px-5" cols="12" md="9">
      <v-dialog v-model="getModal.show" max-width="525">
        <v-card>
          <v-card-title class="headline">
            Seguimiento de Procesos
          </v-card-title>
          <v-card-text>
            <span style="font-size: 16px">{{ getModal.message }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="getModal.show = false">
              Volver
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col cols="12">
        <v-btn
          icon
          title="Número de radicación"
          aria-label="Número de radicación"
        >
          <v-icon size="60">fas fa-clipboard-check</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="mt-1">
        <span
          class="font-weight-bold leading--text mb-3"
          style="font-size: 32px"
          >Seguimiento de Procesos</span
        >
        <br />
        <v-col class="mx-0 mt-5">
          <v-row align="center" justify="center" class="ma-0">
            <v-col cols="6" class="text-right">
              <label for="input-ultimos-dias">Actuaciones de los últimos</label>
            </v-col>
            <v-col cols="6" class="py-0">
              <div class="d-flex align-center">
                <v-form v-model="validUpdateDays" ref="inputUltimosDias" lazy-validation>                
                  <v-text-field
                    id="input-ultimos-dias"
                    v-model="getUserData.diasAConsultar"
                    dense
                    outlined
                    :rules="daysRule"
                    required
                    type="number"
                    maxlength="3"
                    hide-details="auto"
                    style="max-width: 100px; margin-right: 1.4rem"
                  />
                </v-form>
                <span>días</span>
              </div>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="6" class="text-right">
              <label for="checkbox-notificacion-email"
                >Notificación por email cada mañana</label
              >
            </v-col>
            <v-col cols="6" class="py-0">
              <v-checkbox
                id="checkbox-notificacion-email"
                v-model="getUserData.conNotificacionPorEmail"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="ma-0">
            <v-col cols="6" class="text-right">
              <label for="input-proceso-que-contenga"
                >Número de Proceso que contenga</label
              >
            </v-col>
            <v-col cols="6" class="d-flex align-center py-0">
              <v-text-field
                id="input-proceso-que-contenga"
                v-model="getUserData.filtroLlaveProceso"
                dense
                outlined
                required
                type="text"
                hide-details="true"
                style="max-width: 180px;"
              ></v-text-field>
              <div class="ml-3">
                <v-tooltip max-width="300" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      aria-label="Número de radicación"
                    >
                      <v-icon>fas fa-info-circle</v-icon>
                    </v-btn>
                  </template>
                  <span style="max-width: 100px;"
                    >Para filtrar los procesos se utilizan los dígitos y los
                    comodines: "_" para una posición y "%" para cero o más
                    posiciones.</span
                  >
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col cols="6" class="text-right">
              <label for="input-actuaciones-recientes"
                >Solo Procesos con actuaciones recientes</label
              >
            </v-col>
            <v-col cols="6" class="text-right py-0">
              <v-checkbox
                id="input-actuaciones-recientes"
                v-model="getUserData.soloConActuacionesRecientes"
              ></v-checkbox>
            </v-col>
            <!-- <span
              class="col-xs-12 cp-text-danger-block field-validation-valid"
              role="alert"
              data-valmsg-for="DiasAConsultar"
              data-valmsg-replace="true"
            ></span> -->
          </v-row>
          <v-row align="center" justify="center" class="ma-0">
            <v-col cols="6" class="text-right">
              <p>
                Cantidad máxima de procesos a registrar
              </p>
            </v-col>
            <v-col cols="6" class="d-flex align-center py-0">
              <p>
                {{getUserData.procesosPorUsuario}}
              </p>
            </v-col>
          </v-row>
          <v-row align="center" justify="center" class="ma-0">
            <v-col cols="6" class="text-right">
              <label for="checkbox-seguimiento-snapshot"
                >Seguimiento con snapshot/online</label
              >
            </v-col>
            <v-col cols="6" class="d-flex align-center py-0">
              <v-checkbox
                disabled
                id="checkbox-seguimiento-snapshot"
                v-model="getUserData.seguimientoConSnapShot"
              ></v-checkbox>
              <div class="ml-3">
                <v-tooltip max-width="300" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      aria-label="Número de radicación"
                    >
                      <v-icon>fas fa-info-circle</v-icon>
                    </v-btn>
                  </template>
                  <span style="max-width: 100px;"
                    >Cuando está habilitado el snapshot, las actuaciones corresponden al día anterior (calculados en la madrugada). 
                    Online se refiere a que los datos se consultan en tiempo real.</span
                  >
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <span
              class="col-xs-12 cp-text-danger-block field-validation-valid"
              role="alert"
              data-valmsg-for="DiasAConsultar"
              data-valmsg-replace="true"
            ></span>
          </v-row>
          <div class="mt-4">
            <v-btn
              color="primary"
              class="mx-2 font-weight-bold"
              width="200"
              :disabled="!validUpdateDays"
              :loading="isLoading.update"
              aria-label="Consultar Número de radicación"
              @click="updateUserSettings"
              >Actualizar</v-btn
            >
          </div>
        </v-col>
        <v-row align="start" justify="center" class="mt-5">
          <v-col cols="4">
            <v-textarea
              outlined
              label="Procesos en Seguimiento"
              readonly
              v-model="getProcesses.data"
              hide-details="auto"
              height="315px"
            ></v-textarea>
          </v-col>
          <v-col cols="4">
            <v-textarea
              outlined
              label="Edición de lista de procesos"
              v-model="selectedProcesses"
              hide-details="auto"
              height="200px"
              ref="edicionListaProcesos"
            ></v-textarea>
            <v-row align="center">
              <v-col cols="12" md="6">
                <v-btn
                  block
                  :disabled="!validUpdateDays"
                  color="primary"
                  class="font-weight-bold"
                  :loading="isLoading.add"
                  aria-label="Adicionar procesos para seguimiento"
                  @click="addProcesses"
                  >Adicionar</v-btn
                >
              </v-col>
              <v-col cols="12" md="6">
                <v-btn
                  block
                  :disabled="!validUpdateDays"
                  color="error"
                  class="font-weight-bold"
                  :loading="isLoading.delete"
                  aria-label="Consultar Número de radicación"
                  @click="deleteProcesses"
                  >Eliminar</v-btn
                >
              </v-col>
              <v-col cols="12">
                <v-menu :disabled="!validUpdateDays"  offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                      large
                      color="grey"
                      outlined
                      block
                      v-bind="attrs"
                      v-on="on"
                      class="text-none mr-3"
                    >
                      Cargar / Descargar Listado
                      <v-icon
                        right
                        dark
                      >
                        fas fa-chevron-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item-group
                      color="primary"
                    >
                      <v-list-item
                        @click="selectAction(item.value)"
                        v-for="(item, index) in procesos"
                        :key="index"
                      >
                        <v-list-item-avatar>
                          <v-icon v-html="item.icon"></v-icon>
                        </v-list-item-avatar>
                        
                        <v-list-item-title class="font-weight-bold">{{ item.name}}</v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
            <span :v-if="getErrors.template" class="error-message">{{
              getErrors.template
            }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="8" class="font-weight-bold leading--text mb-3">
            <h2>Actuaciones de Procesos en Seguimiento</h2>
          </v-col>
          <v-col cols="4" class="text-left">
            <v-btn
              text
              @click="downloadExcel()"
              class="primary--text text-none font-weight-bold"
            >
              <v-icon
                v-if="!downloadingExcel"
                aria-hidden="true"
                aria-label="Descargar listado de actuaciones en formato Excel"
                large
                color="primary"
                class="mr-2">
                  fas fa-file-excel
              </v-icon>
              <v-progress-circular
                v-else
                class="mr-2"
                indeterminate
                color="primary">
              </v-progress-circular>
              Descargar Excel
            </v-btn>
          </v-col>
        </v-row>
        <!-- </v-col> -->
        <!-- </v-row> -->
      </v-col>
      <!-- <v-col class="pt-0">
        <v-data-table
          :headers="headers"
          :items="getProcesos"
          hide-default-footer
          class="elevation-0 caption"
          mobile-breakpoint="xs"
          :loading="getStatus.loading"
          loading-text="Cargando... Por favor espere"
          ref="table"
        >
          <template v-slot:item.esPrivado="{ item }">
            <v-simple-checkbox
              class="text-center"
              :disabled="getVisited ? false : true"
              color="blue"
              :value="getVisited.includes(item.idProceso)"
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.llaveProceso="{ item }">
            <v-btn text class="blue--text" @click="goToDetails(item.idProceso)"
              >{{ item.llaveProceso }}
            </v-btn>
          </template>
        </v-data-table>
        <div class="mt-8 text-center">
          <Pagination />
        </div>
      </v-col> -->
    </v-col>
    <v-col cols="12">
      <v-data-table
        class="mx-2 mb-2 elevation-0 caption"
        dense
        :headers="headers"
        :items="getActions.usuarioActuaciones"
        item-key="idRegActuacion"
        mobile-breakpoint="xs"
        :loading="getActions.loading"
        loading-text="Cargando... Por favor espere"
        ref="table"
        disable-pagination
        hide-default-footer
      >
        <!-- <template v-slot:[`item.fechaActuacion`]="{ item }">
          {{ formatDate(item.STRT_D) }}
        </template>
        <template v-slot:[`item.fechaInicial`]="{ item }">
          {{ formatDate(item.STRT_D) }}
        </template>
        <template v-slot:[`item.fechaFinal`]="{ item }">
          {{ formatDate(item.STRT_D) }}
        </template>
        <template v-slot:[`item.fechaRegistro`]="{ item }">
          {{ formatDate(item.STRT_D) }}
        </template> -->
        <template v-slot:[`item.fechaActuacion`]="{ item }">
          <!-- <span :style="getFirstColumnStyle(item.llaveProceso)">{{ formatDate(item.fechaActuacion) }}</span> -->
          <!-- <span :class="{fontBold:getFirstColumnBold(item.llaveProceso)}">{{ formatDate(item.fechaActuacion) }}</span> -->
          <span>{{ formatDate(item.fechaActuacion) }}</span>
        </template> 
        <template v-slot:[`item.fechaInicial`]="{ item }">
          {{ formatDate(item.fechaInicial) }}
        </template>
        <template v-slot:[`item.fechaFinal`]="{ item }">
          {{ formatDate(item.fechaFinal) }}
        </template>
        <template v-slot:[`item.fechaRegistro`]="{ item }">
          <span>{{ formatDate(item.fechaRegistro) }}</span>
        </template>
      </v-data-table>
    </v-col>

    <input v-show="false" type="file" @change="uploadFile($event); updateUserSettings()" ref="cargar" />

  </v-row>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("auth", ["getUser"]),
    ...mapGetters("processTracking", [
      "getUserData",
      "isLoading",
      "getProcesses",
      "getActions",
      "getErrors",
      "getModal"
    ]),
  },
  methods: {
    uploadFile(event){     
      let payload = {
        file: event.target.files[0],
        email: this.getUser.email
      }     
      this.$store.dispatch("processTracking/uploadFile", payload)
      .finally(
        this.updateUserSettings()
      )
    },
    downloadExcel(){
      this.downloadingExcel = true      
      let payload = {
        email: this.getUser.email
      }
      this.$store.dispatch("processTracking/downloadExcel", payload)
      .finally(
        this.updateUserSettings()
      )
    },
    selectAction(action) {
      console.log(action)
      if (action === "cargar") {
        this.$refs.cargar.click();
      } else {
        this.$store.dispatch("processTracking/downloadTemplate");
      }
    },
    updateUserSettings() {
      if(this.$refs.inputUltimosDias.validate()){
        this.$store.dispatch("processTracking/updateUserSettings", {
          form: this.getUserData,
          email: this.getUser.email,
        })
      }
      // Show a little progress
      setTimeout(()=>{
        this.downloadingExcel = false
      }, 1000)
    },
    addProcesses() {
      this.$store.dispatch("processTracking/addProcesses", {
        ProcesosAEditar: this.selectedProcesses,
        usuario: this.getUser.email,
      })
      .finally(
        this.updateUserSettings()
      )
      /* Limpiar cuadro de texto
         de los procesos a editar */
      this.selectedProcesses=''
    },
    deleteProcesses() {
      this.$store.dispatch("processTracking/deleteProcesses", {
        ProcesosAEditar: this.selectedProcesses,
        usuario: this.getUser.email,
      })
      .finally(
        this.updateUserSettings()
        // // this.getProcessesAndUserActions
      )
      /* Limpiar cuadro de texto
         de los procesos a editar */
      this.selectedProcesses=''
    },
    formatDate(value) {
      if(value)
        return this.$moment(value).format("YYYY-MM-DD")
      else 
        return ""
    },
    getFirstColumnBold(value){
      // When change the value, also change the font-weight style
      if (this.firstColumnPrev != value)
        this.isfirstColumnBold = !this.isfirstColumnBold

      // Save previous value
      this.firstColumnPrev=value    

    //   if (this.isfirstColumnBold) 
    //     return "{font-weight: bold}" 
    //   else
    //     return "{font-weight: normal}"
      return this.isfirstColumnBold
    }
  },
  mounted() {
    this.$store.dispatch("processTracking/getUserData", {
      email: this.getUser.email,
    });
    this.$store.dispatch("processTracking/getProcesses", {
      email: this.getUser.email,
    });
    this.$store.dispatch("processTracking/getUserActions", {
      email: this.getUser.email,
    });
  },
  created() {
      this.$store.dispatch(
        'process/setUrlAyuda',
        '/manual_aut/funciones.html#generalidades',
      );
  },
  data: () => ({
    downloadingExcel: false,
    firstColumnPrev: '',
    isfirstColumnBold: true,
    validUpdateDays: false,
    daysRule:[
      v => !!v || 'Requerido',
      v => v ? v >= 1 || 'Mínimo 1 dia' : '',
      v => v ? v <= 30 || 'Máximo 30 dias' : '',
    ],
    selectedProcesses: "",
    procesos: [
      {
        name: "Descargar plantilla",
        icon: "fas fa-file-excel",
        value: "descargar",
      },
      {
        name: "Cargar listado",
        icon: "fas fa-upload",
        value: "cargar",
      },
    ],
    headers: [
      {
        text: "Número de Radicación",
        align: "start",
        value: "llaveProceso",
        sortable: false,
        width: "60",
      },
      {
        text: "Demandante",
        value: "demandante",
        sortable: false,
        width: "100",
      },
      /*
      { text: "Fecha de Actuación", value: "fechaActuacion", width: "50" },
      { text: "Actuación", value: "actuacion", sortable: false, width: "100" },
      { text: "Anotación", value: "anotacion", sortable: false, width: "325" },
      { text: "Fecha Inicia Término", value: "fechaInicial", width: "100" },
      { text: "Fecha Finaliza Término", value: "fechaFinal", width: "100" },
      { text: "Fecha de Registro", value: "fechaRegistro", width: "50" },
      */
      { text: "Fecha de Actuación", value: "fechaActuacion", width: "80" },
      { text: "Actuación", value: "actuacion", sortable: false, width: "100" },
      { text: "Anotación", value: "anotacion", sortable: false, width: "325" },
      { text: "Fecha Inicio Término", value: "fechaInicial", width: "90" },
      { text: "Fecha Final Término", value: "fechaFinal", width: "95" },
      { text: "Fecha de Registro", value: "fechaRegistro", width: "90" },
    ],
  }),
};
</script>
<style>
.fontBold {
  font-weight: bold;
}

.error-message {
  color: red;
  font-size: 14px;
  margin: 0;
}

tbody tr:nth-of-type(even) {
  background-color: rgba(236, 237, 237);
}

/* .v-text-field--outlined {
    height: 400px;
    border: 1px solid red;
} */

/* .v-text-field--outlined fieldset {
   border-collapse: collapse;
    border-color: red;
    border-style: solid;
    border-width: 1px;
     min-height: 40px !important;
    /* bottom: 0;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: -5px;
    transition-duration: 0.3s;
    transition-property: color, border-width;
    transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
}

>>> input {*/
/* -webkit-writing-mode: horizontal-tb !important;
    text-rendering: auto;
    color: -internal-light-dark-color(black, white);
    letter-spacing: normal;
    word-spacing: normal;
    text-transform: none;
    text-indent: 0px;
    text-shadow: none;
    display: inline-block;
    text-align: start;
    -webkit-appearance: textfield;
    background-color: -internal-light-dark-color(rgb(255, 255, 255), rgb(59, 59, 59));
    -webkit-rtl-ordering: logical;
    cursor: text;
    margin: 0em;
    font: 400 13.3333px Arial;
    padding: 1px 2px;
    border-width: 2px;
    border-style: inset;
    border-color: red !important;
    height: 50px;;
    border-image: initial;
}
*/
</style>
